import { connect } from 'react-redux'
import { compose } from 'redux'
import { reduxForm } from 'redux-form'

import { SelectRangeBase } from './SelectRange'

import { bookingActions } from 'reduxModules/actions/BookingActions'

const mapDispatchToProps = {
  getRangeBookings: bookingActions.getRangeBookings
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  reduxForm({
    form: 'selectRange'
  })
)

export const SelectRange = enhance(SelectRangeBase)



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/SelectRange/index.js